import React, {useEffect, useState} from 'react';
import {useDropzone} from 'react-dropzone';
import { makeStyles } from '@material-ui/core/styles';
import { getlanguagelist } from "../../helpers/changelanguage";
import './polling.css';
/* import DeleteButton from "./deletebutton"; */

import $ from "jquery";

const useStyles = makeStyles(theme => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
      backgroundColor: theme.palette.background.paper,
    },
    gridList: {
      width: 500,
      
    },
  }))

const thumbsContainer = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: 16
};

const thumb = {
  display: 'inline-flex',
  borderRadius: 2,
  border: '1px solid #eaeaea',
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: 'border-box'
};

const thumbInner = {
  display: 'flex',
  minWidth: 0,
  overflow: 'hidden'
};

const img = {
  display: 'block',
  width: 'auto',
  height: '100%'
};

export default function  Dropzone(props) {
 
  //let languagelist = {};
  let [files] = useState([]);
  if(props.file_list){
    files = props.file_list
  }
   const {getRootProps, getInputProps} = useDropzone({
   }); 
  const removeImage = (idToremove) => { 

    //$("#list_"+idToremove).remove();
    files.splice(idToremove, 1);
    props.setFileList(files); 
    /* files.splice(idToremove, 1);
    props.setFileList(files); 
    $("#list_"+idToremove).remove(); */
  }

 
    
  
  const fileChange = (e) => {
    
    props.changeFile(props.fileIndex,e.target.files[0]);
     
      
  }
 
  
  const classes = useStyles();
    const thumbs =  
    
  
  useEffect(() => () => {
    // Make sure to revoke the data uris to avoid memory leaks
    files.forEach(file => URL.revokeObjectURL(file.preview));
  }, [files]);
  let languagelist = getlanguagelist();
  return (
   
 
      
     
        <div {...getRootProps({className: 'dropzone'})} >
          <input {...getInputProps()} onChange={fileChange} accept='image/*'/>
          <a href={void(0)} className="polling-opt-imgup" id=""> 
              <img src="assets/images/polling-upload-icon.png" />
              <p>{languagelist.poll6}</p>
          </a>
        </div>
        
  );
}




